import React, { Component } from "react";
import Slider from "react-slick";
import ProductCard from "./ProductForSlider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
class ProductSlider extends Component {
  constructor() {
    super();
    this.state = {
      slides: [
            {
              id: 1,  
              title: "Product 1",
              price: 10,
              image: "https://via.placeholder.com/600x400",
            },
            {
              id: 2,  
              title: "Product 2",
              price: 10,
              image: "https://via.placeholder.com/600x400",
            },
            {
              id: 3,
              title: "Product 3",
              price: 24,
              discountedPrice: 10,
              image: "https://via.placeholder.com/600x400",
            },
            {
              id: 1,  
              title: "Product 1",
              price: 10,
              image: "https://via.placeholder.com/600x400",
            },
            {
              id: 2,  
              title: "Product 2",
              price: 10,
              image: "https://via.placeholder.com/600x400",
            },
            {
              id: 3,
              title: "Product 3",
              price: 24,
              discountedPrice: 10,
              image: "https://via.placeholder.com/600x400",
            },
            {
              id: 1,  
              title: "Product 1",
              price: 10,
              image: "https://via.placeholder.com/600x400",
            },
            {
              id: 2,  
              title: "Product 2",
              price: 10,
              image: "https://via.placeholder.com/600x400",
            },
            {
              id: 3,
              title: "Product 3",
              price: 24,
              discountedPrice: 10,
              image: "https://via.placeholder.com/600x400",
            },
      ]
    };
  }
  render() {
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div style={{backgroundColor: "black",color: "white",textAlign: "center"}}>
        <h2>Featured Products</h2>
        <Slider {...settings}>
          {this.state.slides.map((slide, index) => {
            return (
              <div key={slide.id}>
                <ProductCard product={slide} />
                {/* <img src={slide.img} alt={`slide${index}`} /> */}
              </div>
            );
          })}
        </Slider>
      </div>
    );
  }
}

export default ProductSlider;